export default __webpack_public_path__ + "static/xero-hero-img-483376c59233064ca934e9cae40d12b2.png";